import { Box, Heading, Text } from '@wix/design-system'
import React, { FC } from 'react'

import { WixStudioAvatar } from '../../../reusable/WixStudioAvatar'
import { WixStudioSidePanelText } from '../../../reusable/WixStudioSidePanelText'
import { WixStudioTemplateSidePanel } from '../../../reusable/WixStudioTemplate/WixStudioTemplateSidePanel'
import { WixStudioVisual } from '../../../reusable/WixStudioVisual'
import Dots from './Dots.svg'
import s from './SidePanel.scss'

type Invite = {
  letter?: string
  loading?: boolean
  label: string
}

const colors: Record<number, string> = {
  1: '#C0E8E8',
  2: '#E2D8FF',
  3: '#D8E2EC',
}
const getColor = (index: number) => (!index ? '#deff00' : colors[index])

const max = 4

export const SidePanel: FC<{ invites: Invite[]; heading: string; text: string }> = ({ invites, heading, text }) => {
  const invitesToRender = invites.slice(0, max)
  const isALot = invites.length >= max

  return (
    <WixStudioTemplateSidePanel className={s.root}>
      <WixStudioVisual avatar={invites[0]} className={s.visual}>
        <Box direction="vertical" margin="25px 15px 0px" gap="28px" overflow="hidden" width="100%" flex="1">
          <Box verticalAlign="middle">
            <Heading size="extraLarge">{heading.replace(/\$count/g, `${invites.length}`)}</Heading>
            <Box width="67px" height="18px" borderRadius="18px" background="#fff" marginLeft="auto" />
            <Box width="67px" height="18px" borderRadius="18px" background="#DAE1EB" marginLeft="5px" />
          </Box>
          <Box direction="vertical" gap="4px" overflow="hidden">
            {invitesToRender.map((invite, index) => (
              <Box
                key={index}
                marginTop={!index && isALot ? '-64px' : 'initial'}
                gap="10px"
                background="#fff"
                borderRadius="6px"
                height="60px"
                minHeight="60px"
                width="100%"
                verticalAlign="middle"
                padding="0 16px"
                boxSizing="border-box"
                transition="margin-top 0.5s ease-in-out"
              >
                <WixStudioAvatar
                  label={invite.letter || invite.label}
                  loading={invite.loading}
                  background={getColor(index)}
                  d="30px"
                />
                <Text size="small" weight="normal">
                  {invite.label}
                </Text>
                <Box marginLeft="auto">
                  <Dots />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </WixStudioVisual>
      <div className={s.text}>
        <WixStudioSidePanelText text={text} />
      </div>
    </WixStudioTemplateSidePanel>
  )
}
